import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
    const { authState } = useAuth();
    const { isAuthenticated } = authState;

    if (isAuthenticated) {
        return <Navigate to="/keyData" replace />; // Redirect to the dashboard or another appropriate page
    }

    return children; // Render children (Login component) if not authenticated
};

export default PublicRoute
